import { useAuth0 } from '@auth0/auth0-react';
import { Menu } from '@cimplico/components';
import UserAvatar from '../../components/avatar/UserAvatar';
import { DOMAIN } from '../../config';
import { useAuthProfileContext } from '../../providers/AuthProfileProvider';
import { useCurrentUser } from '../../queries/use-current-user';

function OnboardingProfileIcon(): JSX.Element {
    const { logout } = useAuth0();

    const profile = useAuthProfileContext();
    const userQuery = useCurrentUser(profile[`${DOMAIN}/uuid`]);

    const user = userQuery.data?.user;

    return (
        <Menu>
            <Menu.Button>
                {user ? (
                    <UserAvatar user={{ firstName: user.firstName, lastName: user.lastName, avatarUrl: user.avatarUrl }} />
                ) : (
                    <span className="inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100 border">
                        <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                    </span>
                )}
            </Menu.Button>
            <Menu.Body position="left">
                <div className="dark:text-white/[0.60] text-gray-700 cursor-pointer grid items-center py-2 text-sm">
                    <button
                        className="hover:dark:bg-white/[0.09] hover:bg-gray-100 hover:text-gray-900 hover:dark:text-white/[0.87] text-left pl-4 pr-8 py-2"
                        onClick={(): Promise<void> => logout({ logoutParams: { returnTo: window.location.origin } })}
                    >
                        Logout
                    </button>
                </div>
            </Menu.Body>
        </Menu>
    );
}

export default OnboardingProfileIcon;
